var searchPage = {};

(function (searchPageApp) {
    var filterModel = {
        SearchTerm: "",
        Page: 1
    };

    var fromPopState = false;
    var blockPopstateEvent = true;
    var browserSupportsHistoryApi = window.history && 'pushState' in window.history;

    if (browserSupportsHistoryApi) {
        // prevent Chrome from calling onpopstate on initial load
        $(window).on('load', function () {
            // The timeout ensures that popstate-events will be unblocked right
            // after the load event occured, but not in the same event-loop cycle.
            setTimeout(function () { blockPopstateEvent = false; }, 0);
        });

        $(window).on('popstate', function () {
            if (blockPopstateEvent && document.readyState === "complete") {
                return;
            }
            fromPopState = true;
            performSearchFromUrl();
        });
    }

    function pushHistory() {
        if (browserSupportsHistoryApi && !fromPopState) {
            var currentPath = window.location.pathname;
            var query = "?";
            var queryArray = [];
            if (filterModel.SearchTerm) {
                queryArray.push("search=" + filterModel.SearchTerm);
            }
            if (filterModel.Page && filterModel.Page > 1) {
                queryArray.push("page=" + filterModel.Page);
            }
            query += queryArray.join("&");
            history.pushState(null, null, currentPath + query);
        }
        fromPopState = false;
    }

    function performSearchFromUrl() {
        filterModel.SearchTerm = null;
        filterModel.Page = 1;
        searchPageApp.setInputValue();

        if (window.location.search.length > 1) {
            for (var aItKey, nKeyId = 0, aCouples = window.location.search.substr(1).split("&");
                nKeyId < aCouples.length;
                nKeyId++) {
                aItKey = aCouples[nKeyId].split("=");
                if (aItKey.length <= 1)
                    continue;
                var key = decodeURIComponent(aItKey[0]).toLowerCase();
                var val = decodeURIComponent(aItKey[1]);

                if (key === "search") {
                    filterModel.SearchTerm = val;
                    searchPageApp.setInputValue();
                } else if (key === "page") {
                    filterModel.Page = val;
                }
            }
        }
        searchPageApp.GetSearchResults();
    }

    searchPageApp.setInputValue = function () {
        $(".js-search-field").val(filterModel.SearchTerm);
    };

    searchPageApp.GetSearchResults = function () {
        $.ajax({
            url: "/umbraco/surface/SearchSurface/GetFilterResult",
            type: "GET",
            data: filterModel,
            dataType: "html",
            success: function (data) {
                $(".js-search-results").html(data);
                pushHistory();
                searchPageApp.setInputValue();
            }
        });
    };

    $(document).ready(function () {
        //Get url params on load
        const urlParams = new URLSearchParams(window.location.search);

        //check if querystring params exist on load/reload
        if (urlParams.get('search')) {
            filterModel.SearchTerm = urlParams.get('search');
            searchPageApp.setInputValue();
        }

        if (urlParams.get('page'))
            filterModel.Page = urlParams.get('page');
        

        $(".js-search-field").on('keypress', function (e) {
            var code = e.keyCode || e.which;
            if (code === 13) {
                e.preventDefault();
                filterModel.SearchTerm = this.value;
                filterModel.Page = 1;
                searchPageApp.GetSearchResults();
            }
        });

        $(".js-search-button").on('click', function (e) {
            e.preventDefault();
            filterModel.SearchTerm = $(".js-search-field").val();
            filterModel.Page = 1;
            searchPageApp.GetSearchResults();
        });


        $(document).on('click', 'ul.pagination a', function (e) {
            e.preventDefault();
            filterModel.Page = $(this).data('page');
            searchPageApp.GetSearchResults();
            paginationScrollToTop();
        });

        function paginationScrollToTop() {
            $('html, body').animate({
                scrollTop: $(".js-search-results").offset().top - $("header").outerHeight()
            }, 400);
        }
    });

})(searchPage);
